import { ActionEnum } from '../../../actions/types/orderActions.types';
import OrderMassAction from './OrderMassAction';

class MoveToSent extends OrderMassAction {
  mustShowAction(): boolean {
    return this.allOrdersHaveAction([ActionEnum.MOVE_TO_SENT]);
  }
}

export default MoveToSent;
